// MarkdownToggleList.js
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownToggleList = ({ markdownText }) => {
  const [showAll, setShowAll] = useState(false);

  const allLines = (markdownText || "").split('\n');

  const listLines = allLines.filter((line) =>
    line.trim().startsWith('-') || line.trim().startsWith('*')
  );

  const nonListLines = allLines.filter((line) =>
    !(line.trim().startsWith('-') || line.trim().startsWith('*'))
  );

  const threshold = 5;
  const hasMoreThanThreshold = listLines.length > threshold;

  let displayedMarkdown = '';

  if (hasMoreThanThreshold && !showAll) {
    const slicedList = listLines.slice(0, threshold);
    displayedMarkdown = [...nonListLines, ...slicedList].join('\n');
  } else {
    displayedMarkdown = markdownText;
  }

  return (
    <div>
      <ReactMarkdown>{displayedMarkdown}</ReactMarkdown>

      {hasMoreThanThreshold && (
        <a 
          className="btn-showMore"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? 'Show Less' : 'Show More'}
        </a>
      )}
    </div>
  );
};

export default MarkdownToggleList;
